'use client'
import React, {useState} from 'react'
import clsx from 'clsx'
import {motion} from 'motion/react'
import Image, {StaticImageData} from 'next/image'
import {Swiper, SwiperSlide, useSwiper} from 'swiper/react'
import {onboardingAndOffboardingData} from 'v1/content/zenhr-page'
import lineIcon from 'v1/assets/icons/zenhr/home/line.svg'
import {IoIosArrowRoundForward, IoIosArrowRoundBack} from 'react-icons/io'
import classes from './styles.module.css'

import 'swiper/css'
import 'swiper/css/pagination'

export default function OnboardingAndOffboarding() {
  const [activeIndex, setActiveIndex] = useState(0)
  const [swiperInstance, setSwiperInstance] = useState<any>(null)

  const handleIndexChange = (index: number) => {
    setActiveIndex(index)
    if (swiperInstance) {
      swiperInstance.slideTo(index)
    }
  }

  return (
    <div className={classes.container}>
      <ButtonSection activeIndex={activeIndex} handleIndexChange={handleIndexChange} />
      <Swiper
        spaceBetween={10}
        loop={true}
        onSlideChange={swiper => setActiveIndex(swiper.realIndex)}
        onSwiper={setSwiperInstance}
        modules={[]}
        className="mySwiper"
      >
        {onboardingAndOffboardingData.tabs.map((card, idx) => (
          <SwiperSlide key={idx}>
            <ReviewCard card={card} />
          </SwiperSlide>
        ))}
        <ChangeSlide activeIndex={activeIndex} />
      </Swiper>
    </div>
  )
}

interface ReviewCardProps {
  card: {
    title: string
    image: StaticImageData
    mobileImage: StaticImageData
    paragraph: string
    list: string[]
  }
}

const ReviewCard = ({card}: ReviewCardProps) => {
  return (
    <div className={classes.cardArrowContainer}>
      <div className={classes.detailsContainer}>
        <h3 className="h3-v1">{card.title}</h3>
        <p className="paragraph1-v1">{card.paragraph}</p>
      </div>
      <div className={classes.imageContainer}>
        <Image loading="lazy" className={classes.image} src={card.image} alt="client" />
        <Image loading="lazy" className={classes.mobileImage} src={card.mobileImage} alt="client" />
      </div>
    </div>
  )
}

interface ChangeSlideProps {
  activeIndex: number
}

const ChangeSlide = ({activeIndex}: ChangeSlideProps) => {
  const swiper = useSwiper()

  return (
    <div className={classes.arrowSection}>
      <IoIosArrowRoundBack
        style={{cursor: 'pointer'}}
        size={40}
        onClick={() => swiper.slidePrev()}
        className={classes.nextBackIcon}
      />
      {onboardingAndOffboardingData.tabs.map((_, idx) => (
        <span
          key={idx}
          className={clsx(classes.circleDot, {
            [classes.activeCircleDot]: idx === activeIndex,
          })}
        ></span>
      ))}
      <IoIosArrowRoundForward
        style={{cursor: 'pointer'}}
        size={40}
        onClick={() => swiper.slideNext()}
        className={classes.nextBackIcon}
      />
    </div>
  )
}

const ButtonSection = ({
  activeIndex,
  handleIndexChange,
}: {
  activeIndex: number
  handleIndexChange: (index: number) => void
}) => {
  return (
    <div className={classes.buttonContainer}>
      {onboardingAndOffboardingData?.tabs?.map((data, index) => (
        <>
          <motion.button
            key={index}
            className={`${classes.button} ${index === activeIndex ? classes.active : ''}`}
            onClick={() => handleIndexChange(index)} // Update the active card on button click
          >
            {data?.btnText}
          </motion.button>
          {index < onboardingAndOffboardingData?.tabs?.length - 1 && (
            <Image loading="lazy" src={lineIcon} alt="line-icon" />
          )}
        </>
      ))}
    </div>
  )
}
